import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { ProfileLinks, StudentProfile } from "@/types/profileTypes"

export const useProfileData = () => {
  //✅
  return useGenericQuery<StudentProfile>({
    keys: QUERY_KEYS.profile.show(),
    apiEndpoint: ENDPOINTS.profile.show(),
  })
}

export const useSocialLinksData = () => {
  return useGenericQuery<ProfileLinks>({
    keys: QUERY_KEYS.profile.socialLinks(),
    apiEndpoint: ENDPOINTS.profile.socialLinks(),
  })
}
